export function getParams (state){
    return state.params
}



// WEBPACK FOOTER //
// ./src/modules/sales-budgets/getters.js